// React
import React from 'react';
// Internal
import ViewMember from 'pages/ManagePractice/ViewMember/ViewMember';
import config from 'config/config';

class Profile extends React.Component {
    constructor(props) {
        super(props);
        const userDataStr = localStorage.getItem(config.USERDATA);
        this.userData = userDataStr ? JSON.parse(userDataStr) : null;
    }

    render() {
        return (
            <ViewMember memberId={this.userData.id} {...this.props} />
        );
    }
}

export default Profile;
